import React from "react";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuLink,
  MenuList,
} from "@reach/menu-button";
import { VisuallyHidden } from "@react-aria/visually-hidden";
import { css } from "@nju/css";
import { Icon } from "@nju/icons";

interface IMoreButtonProps {
  invoiceUrl?: string;
  onInvoiceSend: () => void;
}

export function MoreButton({ invoiceUrl, onInvoiceSend }: IMoreButtonProps) {
  return (
    <Menu>
      <MenuButton className={styles.button()}>
        <Icon height={21} name="ellipsis-v" width={21} />
        <VisuallyHidden>Zobacz więcej opcji</VisuallyHidden>
      </MenuButton>
      <MenuList className={styles.submenu()}>
        <MenuItem
          className={styles.submenuItem({ first: true })}
          onSelect={onInvoiceSend}
        >
          <span>wyślij mailem</span>
          <Icon height={21} name="mail" tone="accent" width={20} />
        </MenuItem>
        {invoiceUrl && (
          <MenuLink className={styles.submenuItem()} href={invoiceUrl}>
            <span>pobierz pdf</span>
            <Icon height={21} name="download" tone="accent" width={20} />
          </MenuLink>
        )}
      </MenuList>
    </Menu>
  );
}

const styles = {
  mobileWrapper: css({
    display: "flex",
    flexDirection: "column",
    gap: "$15",

    "@fromTablet": {
      display: "none",
    },
  }),
  wrapper: css({
    display: "block",
  }),
  button: css({
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "40px",
    height: "40px",
    background: "$porcelain",
    borderRadius: "28px",
    transition: "background 300ms",
    cursor: "pointer",
    "&:hover": {
      background: "$ripeLemon",
    },
    "&:focus": {
      background: "$ripeLemon",
    },
  }),
  submenu: css({
    backgroundColor: "$white",
    boxShadow: "$popup",
    borderRadius: "$12",
    minWidth: "240px",
  }),
  submenuItem: css({
    variants: {
      first: {
        true: {
          borderBottom: "1px solid $colors$geyser",
        },
      },
    },
    "&[data-selected]": {
      color: "$cerulean",
    },
    display: "flex",
    padding: "$15",
    alignItems: "center",
    justifyContent: "space-between",
  }),
};
